<template lang="pug">
  b-row
    b-col(sm='12')
      b-card
        div(slot='header')
          b-row
            b-col(sm='7')
              strong Quick Report
            b-col.text-right(sm='5')
              template(v-if='isAdmin')
                template(v-if='checklist.revised')
                  b-button.m-1.text-white(variant='danger' @click='updateRevised')
                    i.icon-dislike
                    span.pl-2 Cancel revision
                template(v-else)
                  b-button.m-1.text-white(variant='primary' @click='updateRevised')
                    i.icon-like
                    span.pl-2 Revise the report
              template(v-else)
                tempalte(v-if='checklist.revised')
                  i.icon-like.text-success.font-weight-bold
                  span.p-2.text-success.font-weight-bold Revised report
                template(v-else)
                  i.icon-close.text-danger.font-weight-bold
                  span.p-2.text-danger.font-weight-bold Unrevised report
              b-button.m-1(variant='primary' @click='generateQuickReport')
                i.icon-notebook
                span.pl-2 Generate .pdf
        b-row.pb-2
          b-col(sm='10' xs='9')
            p
              | Q.I. Composites S.r.l. is approved as laboratory for technical competence in the field of Non-Destructive Testing for Range of approved test methods in the field of motor and sailing yachts & automotive by
              strong Germanischer Lloyd
              | - Approval no. GL-LZ 2512 HH
          b-col(sm='2' xs='3')
            .quick-report-logo.certificate-logo
        b-row.qr-separator-row
          b-col(sm='2' xs='3')
            .quick-report-logo.company-logo
          b-col.pt-2(sm='10' xs='9')
            h3 {{ checklist.name }}
            strong.pr-2 Location:
            span {{ checklist.location }}
            br
            strong.pr-2 Reference project:
            span {{ checklist.project.name }}
            br
            strong.pr-2 Object:
            span= '{{ checklist.structure.card_name }}'
      template(v-for='(item, index) in checklist.checklist_items')
        c-checklist-item(
          :index='index'
          :checklistItem='item'
        )
</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import RouteGen from '@/utils/apiRoutes'
  import cChecklistItem from './subcomponents/ShowItem'
  import Messages from '@/utils/notificationsMsg'

  export default {
    name: 'ChecklistShow',
    components: { cChecklistItem },
    data () {
      return {
        isAdmin: Policeman.isAdmin(),
        checklist: {
          project: {},
          structure: {}
        }
      }
    },
    mounted () {
      this.fetchChecklist(this.$route.params.id)
    },
    methods: {
      fetchChecklist (checklistId) {
        let currentPermissions = this.$route.meta.roles
        if (!Policeman.authorize(currentPermissions)) {
          this.showNotification(401)
          this.$route.push({ name: 'Home' })
        }
        let route = RouteGen.show('checklist', checklistId)
        server.get(route)
          .then(res => {
            let checklist = res.data.checklist
            this.$set(this.$data, 'checklist', checklist)
          })
          .catch(err => {
            console.log(err)
          })
      },
      generateQuickReport () {
        if (confirm('Are you sure you want to proceed?\nWe will generate the report and send you an email to download it')) {
          let checklistId = this.$route.params.id
          let route = RouteGen.show('checklist', checklistId) + '/quick_report'
          server.get(route)
            .then(res => {
              this.showNotification(201, 'created', 'Quick report')
            })
            .catch(err => {
              this.showNotification(err.response.status)
            })
        }
      },
      updateRevised () {
        if (this.isAdmin) { this.saveRevised(this.$route.params.id) }
      },
      saveRevised (id = null) {
        let url = RouteGen.edit('checklist', id) + '/revise'
        let messageModifier = 'updated'
        this.$set(this.$data.checklist, 'revised', !this.$data.checklist.revised)
        server.patch(url, { checklist: this.$data.checklist })
          .then(res => {
            this.showNotification(201, messageModifier)
            this.$set(this.$data, 'checklist', res.data.checklist)
          })
          .catch(err => {
            this.showNotification(err.response.status)
          })
      },
      showNotification (status, modifier, resource = 'Checklist') {
        return this.getMessage(Messages.byStatus(status, resource, modifier))
      }
    },
    notifications: {
      getMessage: {}
    }
  }
</script>

<style lang="sass">
  .quick-report-logo
    background-repeat: no-repeat
    background-size: contain
    bacground-position: 50% 0
    height: 100%
  .certificate-logo
    background-image: url('/static/img/qi_cert_logo.png')
  .company-logo
    background-image: url('/static/img/qi_qr_logo.jpg')
  .qr-separator-row
    position: relative
    &:before
      content: ''
      position: absolute
      height: 2px
      width: calc(100% - 15px)
      right: 0
      background-color: black
</style>



// WEBPACK FOOTER //
// src/components/Checklist/Show.vue